import { gsap, ScrollTrigger, CustomEase } from "./globals.js";
document.addEventListener("DOMContentLoaded", () => {
	// Project Card Loader:
	  function createProjectGridTimeline(gridWrap) {
	  const tl = gsap.timeline({
	    paused: true,
	    delay: 1,
	    defaults: {
	      ease: CustomEase.create(
	        "project-bounce",
	        "M0,0 C0.084,0.61 0.202,0.898 0.327,0.977 0.555,1.121 0.661,0.92 1,1"
	      ),
	      duration: 1.25,
	    },
	  });

	  const cards = gridWrap.querySelectorAll(".project-card");

	  tl.fromTo(
	    cards,
	    {
	      y: "20%", // Start at 30% translate from original position (matches your CSS)
	      rotate: -5, // Start with -10 degrees of rotation
	      opacity: 0,
	    },
	    {
	      y: 0, // End with translate(0, 0) (reset to original position)
	      rotate: 0, // End with no rotation
	      opacity: 1,
	      stagger: 0.075,
	      overwrite: "auto",
	      onStart: () => gsap.set(cards, { pointerEvents: "none" }),
	      onComplete: () => gsap.set(cards, { pointerEvents: "auto" }),
	    }
	  );

	  return tl;
	}

	const gridWrap = document.querySelector(".project-grid__wrap");
	if(gridWrap) {
		const timeline = createProjectGridTimeline(gridWrap, true);
		timeline.play();
	}
});
